export const deleteUserData = () => {
  localStorage.removeItem('auth_userdata');
  deleteToken();
};

export const deleteToken = () => {
  localStorage.removeItem('auth_login_context');
};
